export const TYPES = {
  SELECT_ALL_SUCCESS: "income/SELECT_ALL_SUCCESS",
  SELECT_ALL_INCOME_SUCCESS: "income/SELECT_ALL_INCOME_SUCCESS",
};
